import * as React from 'react';

var _path, _rect, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgNfEditIconBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 21,
    fill: "none",
    viewBox: "0 0 55 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2355FC",
    d: "M20.066 5.692h5.902v1.664h-4.147v2.158h3.731v1.664h-3.731v2.158h4.147V15h-5.902V5.692zm7.706 0h3.146c.97 0 1.816.195 2.535.585a4.09 4.09 0 011.664 1.638c.39.702.585 1.512.585 2.431s-.195 1.729-.585 2.431a4.095 4.095 0 01-1.664 1.638c-.72.39-1.564.585-2.535.585h-3.146V5.692zm3.068 7.644c1.005 0 1.772-.264 2.301-.793.529-.537.793-1.27.793-2.197s-.264-1.655-.793-2.184c-.529-.537-1.296-.806-2.3-.806h-1.314v5.98h1.313zm6.53-7.644h1.755V15H37.37V5.692zm5.757 1.664h-2.6V5.692h6.955v1.664h-2.6V15h-1.755V7.356z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 20,
    x: 0.5,
    y: 0.5,
    stroke: "#2355FC",
    rx: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2355FC",
    d: "M9.426 14.901a.453.453 0 01-.36-.063.45.45 0 01-.2-.308l-.185-1.214L12.435 7.1l1.943 1.173-3.753 6.216-1.16.4a.152.152 0 01-.04.012zm5.186-7.017l-1.943-1.173.704-1.165a.451.451 0 01.623-.154l1.165.704a.454.454 0 01.154.623l-.703 1.165z"
  })));
}

export { SvgNfEditIconBlue as ReactComponent };
//# sourceMappingURL=nf_editIconBlue.svg.js.map
